import React, { FC } from 'react';
import { OperatorPanelNoConnectorProps } from './OperatorPanelNoConnector';
import { ContentUnavailableCentralPart } from './ContentUnavailableCentralPart';
import { scale as initialScale } from '@components/frame';
import UnavailableContent from './UnavailableContent';
import { connect } from 'react-redux';
import { Connector } from '@components/operatorPanel';
import i18n from 'i18n-js';
import { font as initialFont } from '@styles/fonts';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface OperatorPanelConnectorOfflineProps extends OperatorPanelNoConnectorProps {
  connector: Connector;
}

const OperatorPanelConnectorOffline: FC<OperatorPanelConnectorOfflineProps> = ({
  CC,
  machineName,
  isOperator,
  machineStatus,
  time,
  insetBottom,
  insetTop,
  connector,
  scale = initialScale,
  font = initialFont,
}) => {
  const connectorDetails = connector?.connectorDetails;
  const connectorUrl = connectorDetails
    ? `${connectorDetails?.localHost}${connectorDetails?.dnsSuffix ? '.' + connectorDetails?.dnsSuffix : ''} (${connectorDetails?.ipAddressLocal})`
    : '';

  const text = connectorUrl ? i18n.t('Start the Connector on {{connectorUrl}} or download the Connector again.', { connectorUrl }) : '';

  return (
    <UnavailableContent {...{ CC, machineName, machineStatus, isOperator, insetBottom, insetTop, scale, font, testID: TEST_IDS.operatorPanel.unavailable.connectorOffline }}>
      <ContentUnavailableCentralPart
        {...{
          CC,
          iconConfig: { icon: 'connectorOfflineLarge', width: scale(300), height: scale(220), color: CC('Label/Light/Error') },
          title: 'Connector Offline',
          text,
          textAlreadyTranslated: true,
          time,
          scale,
          font,
        }}
      />
    </UnavailableContent>
  );
};

export default connect(({ connector }) => ({ connector }), {})(OperatorPanelConnectorOffline);
